import { MetricWithDomain } from '@weenat/client/dist/core/measurements'
import { JSX } from 'react'
import { IconProps } from '../Icon'
import { Circle, Irrelis } from './generic-icons'
import GenericIcon from './GenericIcon'
import {
  AcUnit,
  Capacitive,
  CloudCoverage,
  Etp,
  EtpSum,
  Humidity,
  HydricPotential,
  Irrigation,
  IrrigationSum,
  LeafWetness,
  PhotosyntheticActiveRadiation,
  Rainfalls,
  RainfallsSum,
  SoilWaterContent,
  SolarFlares,
  Temperature,
  TemperatureDry,
  TemperatureGround,
  TemperatureGroundByDepth,
  TemperatureWet,
  VaporPressureDeficit,
  WaterElectroConductivity,
  WaterTank,
  Wind,
  WindDirection
} from './metric-icons'

const MetricIcons: Record<MetricWithDomain, (props: IconProps) => JSX.Element> = {
  // Not used but avoid type errors
  CAPA: (props: IconProps) => <GenericIcon svg={<Circle />} {...props} />,
  CLDC: (props: IconProps) => <GenericIcon svg={<CloudCoverage />} {...props} />,
  COLD_T_HOUR: (props: IconProps) => <GenericIcon svg={<AcUnit />} {...props} />,
  DD: (props: IconProps) => <GenericIcon svg={<WindDirection />} {...props} />,
  // Not used but avoid type errors
  DRN: (props: IconProps) => <GenericIcon svg={<Circle />} {...props} />,
  DXY: (props: IconProps) => <GenericIcon svg={<WindDirection />} {...props} />,
  ECP: (props: IconProps) => <GenericIcon svg={<WaterElectroConductivity />} {...props} />,
  etp: (props: IconProps) => <GenericIcon svg={<Etp />} {...props} />,
  etpAccumulation: (props: IconProps) => <GenericIcon svg={<EtpSum />} {...props} />,
  FF: (props: IconProps) => <GenericIcon svg={<Wind />} {...props} />,
  FXY: (props: IconProps) => <GenericIcon svg={<Wind />} {...props} />,
  HDEF: (props: IconProps) => <GenericIcon svg={<Irrelis />} {...props} />,
  heatAccumulation: (props: IconProps) => <GenericIcon svg={<Temperature />} {...props} />,
  HPOT: (props: IconProps) => <GenericIcon svg={<HydricPotential />} {...props} />,
  IRR_ACCUMULATION: (props: IconProps) => <GenericIcon svg={<IrrigationSum />} {...props} />,
  IRR: (props: IconProps) => <GenericIcon svg={<Irrigation />} {...props} />,
  irrigation: (props: IconProps) => <GenericIcon svg={<Irrigation />} {...props} />,
  leafWetnessAccumulation: (props: IconProps) => <GenericIcon svg={<LeafWetness />} {...props} />,
  LW_D: (props: IconProps) => <GenericIcon svg={<LeafWetness />} {...props} />,
  LW_V: (props: IconProps) => <GenericIcon svg={<LeafWetness />} {...props} />,
  PPFD_MAX: (props: IconProps) => (
    <GenericIcon svg={<PhotosyntheticActiveRadiation />} {...props} />
  ),
  PPFD_MIN: (props: IconProps) => (
    <GenericIcon svg={<PhotosyntheticActiveRadiation />} {...props} />
  ),
  PPFD: (props: IconProps) => <GenericIcon svg={<PhotosyntheticActiveRadiation />} {...props} />,
  // Not used but avoid type errors
  rainfallIntensity: (props: IconProps) => <GenericIcon svg={<Circle />} {...props} />,
  RR_ACCUMULATION: (props: IconProps) => <GenericIcon svg={<RainfallsSum />} {...props} />,
  RR: (props: IconProps) => <GenericIcon svg={<Rainfalls />} {...props} />,
  RRAccumulation: (props: IconProps) => <GenericIcon svg={<Rainfalls />} {...props} />,
  SSI_HOURS: (props: IconProps) => <GenericIcon svg={<SolarFlares />} {...props} />,
  SSI_HOURSAccumulation: (props: IconProps) => <GenericIcon svg={<SolarFlares />} {...props} />,
  SSI_MAX: (props: IconProps) => <GenericIcon svg={<SolarFlares />} {...props} />,
  SSI_MIN: (props: IconProps) => <GenericIcon svg={<SolarFlares />} {...props} />,
  SSI: (props: IconProps) => <GenericIcon svg={<SolarFlares />} {...props} />,

  SWC: (props: IconProps) => <GenericIcon svg={<SoilWaterContent />} {...props} />,
  T_CAL: (props: IconProps) => <GenericIcon svg={<TemperatureGroundByDepth />} {...props} />,
  T_CAPA: (props: IconProps) => <GenericIcon svg={<TemperatureGroundByDepth />} {...props} />,
  T_DEW: (props: IconProps) => <GenericIcon svg={<Temperature />} {...props} />,
  T_DRY: (props: IconProps) => <GenericIcon svg={<TemperatureDry />} {...props} />,
  T_SOIL_BY_HORIZON: (props: IconProps) => (
    <GenericIcon svg={<TemperatureGroundByDepth />} {...props} />
  ),
  T_SOIL: (props: IconProps) => <GenericIcon svg={<TemperatureGround />} {...props} />,
  T_WET: (props: IconProps) => <GenericIcon svg={<TemperatureWet />} {...props} />,
  T: (props: IconProps) => <GenericIcon svg={<Temperature />} {...props} />,
  // Not used but avoid type errors
  THI: (props: IconProps) => <GenericIcon svg={<Circle />} {...props} />,
  // Not used but avoid type errors
  TN: (props: IconProps) => <GenericIcon svg={<Circle />} {...props} />,
  // Not used but avoid type errors
  TX: (props: IconProps) => <GenericIcon svg={<Circle />} {...props} />,
  U_CAPA: (props: IconProps) => <GenericIcon svg={<Capacitive />} {...props} />,
  U: (props: IconProps) => <GenericIcon svg={<Humidity />} {...props} />,
  // Not used but avoid type errors
  UN: (props: IconProps) => <GenericIcon svg={<Circle />} {...props} />,
  // Not used but avoid type errors
  UX: (props: IconProps) => <GenericIcon svg={<Circle />} {...props} />,
  // Not used but avoid type errors
  VOLT: (props: IconProps) => <GenericIcon svg={<Circle />} {...props} />,
  VPD: (props: IconProps) => <GenericIcon svg={<VaporPressureDeficit />} {...props} />,
  WATER_TANK_LEVEL: (props: IconProps) => <GenericIcon svg={<WaterTank />} {...props} />,
  VIRTUAL_WATER_TANK_LEVEL: (props: IconProps) => <GenericIcon svg={<WaterTank />} {...props} />,

  // Not used but avoid type errors
  WATER_TANK_MAX: (props: IconProps) => <GenericIcon svg={<Circle />} {...props} />,
  SURVIVAL_WATER_TANK: (props: IconProps) => <GenericIcon svg={<Circle />} {...props} />,
  READILY_WATER_CONTENT: (props: IconProps) => <GenericIcon svg={<Circle />} {...props} />,
  VIRTUAL_WATER_TANK_MAX: (props: IconProps) => <GenericIcon svg={<WaterTank />} {...props} />,
  VIRTUAL_SURVIVAL_WATER_TANK: (props: IconProps) => <GenericIcon svg={<WaterTank />} {...props} />,
  VIRTUAL_READILY_WATER_CONTENT: (props: IconProps) => <GenericIcon svg={<Circle />} {...props} />
}

export default MetricIcons
